import React from "react";
import "./Contact.css";

const Contact = () => (
  <div className="contact" id="contact">
    <div className="footer-left">
      <h1>
        TURNING  <br />
        IDEAS INTO 
        <br /> CODE 🚀
      </h1>
    </div>
    <div className="footer-right">
      <h3>I'M ALWAYS INTERESTED ABOUT</h3>
      <div className="interests">
        <p>Frontend Development</p>
        <p>Backend Development</p>
        <p>Startups</p>
        <p>AI</p>
        <p>New Opportunities</p>
        <p>Football</p>
        <p>Cars</p>
        <p>Coffee</p>
      </div>
      <hr />
      <h3>
        MINDING A PROJECT?
        <span>
          <a href="mailto:redi_ibra04@outlook.com">Contact Me</a>
        </span>
      </h3>
      <hr />
      <div className="social">
        <span>
          <a
            href="https://github.com/RediIbra"
            target="_blank"
            rel="noreferrer"
          >
            GITHUB
          </a>
        </span>
        <span>
          {" "}
          <a
            href="https://www.linkedin.com/in/redi-ibra4/"
            target="_blank"
            rel="noreferrer"
          >
            LINKEDIN
          </a>
        </span>
      </div>
    </div>
  </div>
);

export default Contact;
